import { Injectable } from '@angular/core'

// todo change to something like `injectWindow()` --> how does material work with the global window object?
//  or preferred: inject(WINDOW) with a proper injection token that uses a factory which might return null
@Injectable({ providedIn: 'root' })
export abstract class WindowRef {
  get nativeWindow(): null | Window {
    return (typeof window !== 'undefined' && window) || null
  }
}
